import { render, staticRenderFns } from "./CaseProgressCard.vue?vue&type=template&id=caf010d6&scoped=true&"
import script from "./CaseProgressCard.vue?vue&type=script&lang=js&"
export * from "./CaseProgressCard.vue?vue&type=script&lang=js&"
import style0 from "./CaseProgressCard.vue?vue&type=style&index=0&id=caf010d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf010d6",
  null
  
)

export default component.exports